module.exports = __webpack_public_path__ + "images/hikakaku-uttyari_3c2c48f23712164b114f89a5947f2230.png";